import { roundUpDecimal } from "@/helpers/numberHelpers";
import {
  DatasetAttributeSchema,
  DatasetDataColumn,
  DatasetDataRowValue
} from "@/types/dataset";

import { isOrdinalType } from "./dataset";

const getColumnName = (
  col: DatasetAttributeSchema | DatasetDataColumn
): string => {
  if ("name" in col) return col.name;
  if ("attribute_name" in col) return col.attribute_name;
  throw new Error("Column must have either name or attribute_name");
};

export const processValue = (
  value: DatasetDataRowValue,
  column: DatasetAttributeSchema | DatasetDataColumn,
  properties: Record<string, string | number | boolean | null | undefined> = {}
): void => {
  const { data_type } = column;
  const columnName = getColumnName(column);

  // For ordinal type, use an empty string value for null and undefined. This is necessary for coloring map features that can only take string values.
  const ordinalValue = value ?? "";

  const nonOrdinalValue =
    typeof value === "number" ? roundUpDecimal(value, 3) : value;

  properties[columnName] = isOrdinalType(data_type)
    ? ordinalValue
    : nonOrdinalValue;
};
